/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { ColumnVisibilityModel, SizeModel, SortModel } from '@app/core/types';
import { createAction, props } from '@ngrx/store';

export const sortModel = createAction('[Sort Model] Sort Model', props<{ key: string; model: SortModel[] }>());
export const sizeModel = createAction('[Size Model] Size Model', props<{ key: string; model: SizeModel[] }>());
export const columnVisibilityModel = createAction(
  '[Column Visibility Model] Column Visibility Model',
  props<{ key: string; model: ColumnVisibilityModel[] }>(),
);
